import BasicButton from "components/General/BasicButton";
import { useNavigate } from "react-router-dom";
import { actions } from "utils/game-information-constants";

import { mapNumberToColor } from "utils/game_utils";


export default function WaterLevelLegend() {
    const waterLevels = [];
    for (let n = 40; n >= 0; n -= 10) {
      waterLevels.push(n);
    }

    return (
      <div className="flex flex-row space-x-4 p-2 overflow-x-auto">
        {waterLevels.map((level, i) => (
          <div key={i} className="flex flex-col items-center">
            <div className="rounded h-10 w-10" style={{
              backgroundColor: mapNumberToColor(
                level, 0, 40, '#62f0ed', '#081a63', '#C79428',
              ),
            }} />
            <label className="text-sm">{(level < 0 ? "" : "+") + `${level}cm`}</label>
          </div>
        ))}
      </div>
    );
}
